import { useGetWorkspaceTimezone } from '@shared/hooks/use-get-workspace-timezone';
import dayjs from 'dayjs';
import { useMemo } from 'react';

export function useChatPreviewTime(at?: string | null): string {
  const { transformDateFormat, timezone } = useGetWorkspaceTimezone();

  return useMemo(() => {
    if (!at) return '';

    try {
      const isToday = dayjs(at).tz(timezone).isSame(dayjs().tz(timezone), 'day');

      return transformDateFormat(at, isToday ? 'hh:mm A' : 'MMM D');
    } catch {
      return '';
    }
  }, [at, timezone, transformDateFormat]);
}
